import { render, staticRenderFns } from "./CampaignResult.vue?vue&type=template&id=360b82a8&"
import script from "./CampaignResult.vue?vue&type=script&lang=js&"
export * from "./CampaignResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports